/* eslint-disable react/prop-types */
import React, { useState } from "react";
import { useLocation } from "react-router";
import { useSelector } from "react-redux";

export default function InstructionsVideo() {
  const { videoURL } = useSelector((state) => ({
    videoURL: state.Auth?.videoURL,
  }));
  return (
    <div>
      <video
        width="100%"
        controls
        autoPlay
        muted
        loop
        controlsList="nodownload nofullscreen noplaybackrate"
        disablePictureInPicture
        style={{ aspectRatio: "16 / 7", width: "100%", objectFit: "cover" }}
      >
        <source src={videoURL} type="video/mp4" />
      </video>
    </div>
  );
}
